import type { Dispatch } from "react";

import type { Conversation, GroupParticipant } from "@/api/models";
import type { Action } from "@/state/AppStateContext";

export const mergeGroupParticipants = (
  currentParticipants: GroupParticipant[] = [],
  incomingParticipants: GroupParticipant[] = [],
): GroupParticipant[] => {
  const merged = [...currentParticipants];
  const existingIds = new Set(currentParticipants.map((participant) => participant.userId));

  incomingParticipants.forEach((participant) => {
    if (existingIds.has(participant.userId)) return;
    merged.push(participant);
    existingIds.add(participant.userId);
  });

  return merged;
};

export const replaceConversationParticipants = (
  conversation: Conversation,
  participants: GroupParticipant[],
): Conversation => ({
  ...conversation,
  participants,
});

export const syncGroupConversationState = (
  dispatch: Dispatch<Action> | undefined,
  currentChat: Conversation | null | undefined,
  conversation: Conversation,
) => {
  if (!dispatch) return;

  dispatch({ type: "UPDATE_GROUP_CHAT", payload: conversation });

  if (currentChat?.id !== conversation.id) return;

  dispatch({
    type: "UPDATE_CURRENT_CHAT",
    payload: {
      ...currentChat,
      ...conversation,
      messages: conversation.messages.length > 0 ? conversation.messages : currentChat.messages,
    },
  });
};
